import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon/help.svg';
import _imports_1 from '../../assets/icon/user.svg';
import _imports_2 from '../../assets/icon/corporation.svg';
import _imports_3 from '../../assets/icon/home.svg';
import _imports_4 from '../../assets/icon/setting.svg';
import _imports_5 from '../../assets/icon/logout.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1bae23a0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "global-nav",
  ref: "globalNav"
};
var _hoisted_2 = {
  key: 0,
  class: "left"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "right"
};
var _hoisted_5 = {
  key: 0,
  class: "choose-biz"
};
var _hoisted_6 = {
  key: 0,
  class: "add-biz-wrap"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icontianjia"
  }, null, -1);
});

var _hoisted_8 = /*#__PURE__*/_createTextVNode("新建空间 ");

var _hoisted_9 = [_hoisted_7, _hoisted_8];
var _hoisted_10 = {
  key: 1
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode("帮助文档");

var _hoisted_12 = ["href"];

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_14 = [_hoisted_13];
var _hoisted_15 = {
  key: 2
};
var _hoisted_16 = {
  class: "name"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  key: 1,
  src: _imports_1,
  class: "user",
  alt: ""
};
var _hoisted_19 = {
  class: "menulist"
};
var _hoisted_20 = {
  class: "name"
};
var _hoisted_21 = {
  key: 0
};
var _hoisted_22 = {
  key: 0
};
var _hoisted_23 = ["href"];

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "企业列表", -1);
});

var _hoisted_26 = [_hoisted_24, _hoisted_25];
var _hoisted_27 = {
  key: 1
};
var _hoisted_28 = ["href"];

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "企业设置", -1);
});

var _hoisted_31 = [_hoisted_29, _hoisted_30];
var _hoisted_32 = {
  key: 2
};
var _hoisted_33 = ["href"];

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }, null, -1);
});

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "个人设置", -1);
});

var _hoisted_36 = [_hoisted_34, _hoisted_35];
var _hoisted_37 = {
  key: 1
};

var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }, null, -1);
});

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1);
});

var _hoisted_40 = [_hoisted_38, _hoisted_39];
import { reactive, ref, watch, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import UserService from '@/api/user';
import CompanyService from '@/api/company';
import { messageDesc, pathMap, isBcenterEnv } from '@/config/constant';
import AuthService from '@/api/auth';
import { debounce, getCookie } from '@/utils/index';
import { ElMessage } from 'element-plus';
import { dispatchAction } from '@/store/utils';
import defaultLogo from '../../assets/dataauth.png';
import { genHrefOpenUrlNoDecode } from '@/utils/login';
import { appFeature } from '@/config/company';
export default /*#__PURE__*/_defineComponent({
  props: {
    showAvatar: Boolean,
    showCompany: Boolean,
    showBizlist: Boolean,
    showCorpList: Boolean,
    showHelp: Boolean
  },
  setup: function setup(__props) {
    var props = __props;
    var _window$AppConfig = window.AppConfig,
        isPrivateEnv = _window$AppConfig.isPrivateEnv,
        headerConfig = _window$AppConfig.header,
        _window$AppConfig$bas = _window$AppConfig.baseRouter,
        baseRouter = _window$AppConfig$bas === void 0 ? '' : _window$AppConfig$bas;
    var logo = headerConfig.logo,
        _headerConfig$menuMap = headerConfig.menuMap,
        menuMap = _headerConfig$menuMap === void 0 ? {} : _headerConfig$menuMap,
        showHelpDoc = headerConfig.showHelpDoc;
    var headerLogo = logo && (/https?:\/\//.test(logo) ? logo : defaultLogo);
    var route = useRoute();
    var router = useRouter();
    var corporationId = ref('');
    var corporationName = ref('');
    var routeName = ref('');
    var bizId = ref('');
    var bizName = ref('');
    var searchValue = ref('');
    var currentApp = ref('');
    var companyData = reactive({
      companyList: []
    });
    var bizData = reactive({
      bizList: []
    }); // let bizList = reactive([]) as BizItemParams[];
    // vuex

    var store = useStore();
    var userDetail = computed(function () {
      return store.state.user.userDetail;
    });
    var status = computed(function () {
      return store.state.company.status;
    });
    var isAdmin = computed(function () {
      return store.state.company.isAdmin;
    });
    var showCompanySetting = computed(function () {
      var _companyData$companyL;

      return props.showCompany && isAdmin.value && !!((_companyData$companyL = companyData.companyList) !== null && _companyData$companyL !== void 0 && _companyData$companyL.length) && headerConfig.showCompanySetting;
    });
    var showCompanyList = computed(function () {
      return props.showCompany && corporationId.value !== 'demo' && !!companyData.companyList.length && headerConfig.showCompanyList;
    });
    var showUserAccount = computed(function () {
      return !isBcenterEnv && headerConfig.showUserAccount;
    });
    var showLogout = computed(function () {
      return !isBcenterEnv && headerConfig.showLogout;
    });
    var showSettingMenu = computed(function () {
      return showCompanySetting.value || showCompanyList.value || showUserAccount.value;
    });
    var showNewSpace = computed(function () {
      return isAdmin.value && headerConfig.showNewSpace;
    });
    var bizOptions = computed(function () {
      if (!showNewSpace.value) {
        return bizData.bizList.map(function (item) {
          return {
            value: item.id,
            label: item.name
          };
        });
      }

      return bizData.bizList.map(function (item) {
        return {
          value: item.id,
          label: item.name
        };
      }).concat([{
        value: '',
        label: ''
      }]);
    });
    var helpDoc = computed(function () {
      var _route$query$app_key, _appFeature$appKey;

      var appKey = ((_route$query$app_key = route.query.app_key) === null || _route$query$app_key === void 0 ? void 0 : _route$query$app_key.toString()) || '';
      var helpDoc = (_appFeature$appKey = appFeature[appKey]) === null || _appFeature$appKey === void 0 ? void 0 : _appFeature$appKey.helpDoc;
      return (isPrivateEnv ? helpDoc === null || helpDoc === void 0 ? void 0 : helpDoc.private : helpDoc === null || helpDoc === void 0 ? void 0 : helpDoc.saas) || '';
    }); // methods
    // 获取通过的公司列表

    var getCompanyList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _route$params$company, _data$data;

        var data, _data$data$result, _companyData$companyL2, currentCompany, _ref2, _ref2$corporation_id, corporation_id, _ref2$corporation_nam, corporation_name;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getCompanyList();

              case 2:
                data = _context.sent;
                corporationId.value = corporationId.value || ((_route$params$company = route.params.company_id) === null || _route$params$company === void 0 ? void 0 : _route$params$company.toString());

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  companyData.companyList = (_data$data$result = data.data.result) === null || _data$data$result === void 0 ? void 0 : _data$data$result.filter(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.corporation_id) !== 'demo';
                  });

                  if ((_companyData$companyL2 = companyData.companyList) !== null && _companyData$companyL2 !== void 0 && _companyData$companyL2.length && corporationId.value !== 'demo') {
                    currentCompany = corporationId.value ? companyData.companyList.filter(function (item) {
                      return item.corporation_id === corporationId.value;
                    })[0] : companyData.companyList[0];
                    _ref2 = currentCompany || {}, _ref2$corporation_id = _ref2.corporation_id, corporation_id = _ref2$corporation_id === void 0 ? '' : _ref2$corporation_id, _ref2$corporation_nam = _ref2.corporation_name, corporation_name = _ref2$corporation_nam === void 0 ? '' : _ref2$corporation_nam;
                    corporationId.value = corporation_id;
                    corporationName.value = corporation_name;
                  }
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'success'
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyList() {
        return _ref.apply(this, arguments);
      };
    }();

    var initCompany = function initCompany() {
      if (props.showCorpList || props.showCompany) {
        getCompanyList();
      }
    }; // 只有有所属公司时，才能跳转


    var clickLogoHandler = function clickLogoHandler() {
      // 套件内直接跳转控制台
      if (window.__MICRO_APP_ENVIRONMENT__) {
        var _window, _window$microApp;

        var _window$microApp$getD = (_window = window) === null || _window === void 0 ? void 0 : (_window$microApp = _window.microApp) === null || _window$microApp === void 0 ? void 0 : _window$microApp.getData(),
            globalAPI = _window$microApp$getD.globalAPI;

        globalAPI.router.subAppReplace('console', '/');
      }
    };

    var logout = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var _result$data;

        var result, _route$query, _route$query2, redirectUrl;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _context2.next = 3;
                return UserService.logout();

              case 3:
                result = _context2.sent;

                if (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.code) === 1) {
                  ElMessage({
                    message: messageDesc.logoutSuccess,
                    type: 'success'
                  });
                  redirectUrl = (_route$query = route.query) !== null && _route$query !== void 0 && _route$query.redirect_url ? "?redirect_url=".concat(encodeURIComponent(((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.redirect_url.toString()) || '')) : '';
                  location.href = genHrefOpenUrlNoDecode("".concat(baseRouter, "/login").concat(redirectUrl));
                } else {
                  ElMessage({
                    message: result.data.msg,
                    type: 'error'
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function logout(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    var fetchBizList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bizNameOrId) {
        var currentApp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                currentApp = route.params.project;
                _context3.next = 3;
                return AuthService.getBizList({
                  appKey: currentApp === null || currentApp === void 0 ? void 0 : currentApp.toString(),
                  ba_key: getCookie('ba_key'),
                  corporationId: corporationId.value,
                  bizNameOrId: bizNameOrId || ''
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchBizList(_x2) {
        return _ref4.apply(this, arguments);
      };
    }(); // 获取空间信息


    var getBizInfo = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data2;

        var _route$params, bizId, currentApp, corpData, data, _data$data$result2, currentBiz, _ref6, name;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _route$params = route.params, bizId = _route$params.biz_url, currentApp = _route$params.project;
                _context4.next = 3;
                return AuthService.getBizCorporation({
                  bizId: bizId.toString() || '',
                  appKey: currentApp === null || currentApp === void 0 ? void 0 : currentApp.toString()
                });

              case 3:
                corpData = _context4.sent;

                if (corpData.data.code !== 1) {
                  ElMessage({
                    message: corpData.data.msg,
                    type: 'error'
                  });
                }

                corporationId.value = corpData.data.result;
                store.dispatch('company/getCompanyInfo', {
                  corporation_id: corporationId.value
                });
                _context4.next = 9;
                return fetchBizList();

              case 9:
                data = _context4.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  bizData.bizList = (_data$data$result2 = data.data.result) === null || _data$data$result2 === void 0 ? void 0 : _data$data$result2.itemList;
                  currentBiz = bizData.bizList.filter(function (item) {
                    return item.id === bizId;
                  });
                  _ref6 = currentBiz[0] || {}, name = _ref6.name;
                  bizName.value = currentBiz.length ? name : '';
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getBizInfo() {
        return _ref5.apply(this, arguments);
      };
    }(); // 搜索新增成员


    var searchBiz = debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _bizData$data;

      var bizData, _bizData$data$result;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.fetchBizList(this.searchValue);

            case 2:
              bizData = _context5.sent;

              if (((_bizData$data = bizData.data) === null || _bizData$data === void 0 ? void 0 : _bizData$data.code) === 1) {
                this.bizList = (_bizData$data$result = bizData.data.result) === null || _bizData$data$result === void 0 ? void 0 : _bizData$data$result.itemList;
              } else {
                ElMessage({
                  message: bizData.data.msg,
                  type: 'error'
                });
              }

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    })), 200);

    var openNewBizPage = function openNewBizPage() {
      window.open("".concat(location.origin).concat(baseRouter, "/spacelist?corp_id=").concat(corporationId.value, "&app_key=").concat(currentApp.value, "&new_biz=1"));
    }; // 切换空间


    var changeBiz = function changeBiz(id) {
      if (!id) {
        return;
      } // 解决ts中括号读取对象中值的时候报错


      var getRoutePath = function getRoutePath(arg) {
        return pathMap[arg];
      };

      router.push("/authority/".concat(id, "/").concat(getRoutePath(routeName.value), "/").concat(currentApp.value));
    }; // check是否是企业管理员


    var checkCorporationAdmin = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _data$data3, _data$data3$result;

        var data, corporationId;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return CompanyService.getCorprationInfo({
                  bizId: bizId.value,
                  appKey: currentApp.value
                });

              case 2:
                data = _context6.sent;
                corporationId = (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$result = _data$data3.result) === null || _data$data3$result === void 0 ? void 0 : _data$data3$result.corporationId;

                if (corporationId) {
                  // checkCompanyAdmin({ corporation_id: corporationId });
                  dispatchAction('company', 'checkCompanyAdmin', {
                    corporation_id: corporationId
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function checkCorporationAdmin() {
        return _ref8.apply(this, arguments);
      };
    }(); // watch


    watch(route, function (to, from) {
      var _route$name, _route$params2, _route$params2$projec, _to$params, _to$params3, _from$params, _to$query;

      routeName.value = ((_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.toString()) || '';
      currentApp.value = ((_route$params2 = route.params) === null || _route$params2 === void 0 ? void 0 : (_route$params2$projec = _route$params2.project) === null || _route$params2$projec === void 0 ? void 0 : _route$params2$projec.toString()) || ''; // 切换空间

      if (props.showBizlist && (_to$params = to.params) !== null && _to$params !== void 0 && _to$params.biz_url) {
        var _to$params2;

        bizId.value = ((_to$params2 = to.params) === null || _to$params2 === void 0 ? void 0 : _to$params2.biz_url.toString()) || '';
        getBizInfo();
        checkCorporationAdmin();
      } // 切换企业


      if (((_to$params3 = to.params) === null || _to$params3 === void 0 ? void 0 : _to$params3.company_id) !== ((_from$params = from.params) === null || _from$params === void 0 ? void 0 : _from$params.company_id)) {
        var _to$params$company_id;

        corporationId.value = ((_to$params$company_id = to.params.company_id) === null || _to$params$company_id === void 0 ? void 0 : _to$params$company_id.toString()) || '';
        initCompany();
      } // 产品选择页及空间列表页


      if ((_to$query = to.query) !== null && _to$query !== void 0 && _to$query.corp_id) {
        var _to$query2, _to$query2$corp_id;

        corporationId.value = ((_to$query2 = to.query) === null || _to$query2 === void 0 ? void 0 : (_to$query2$corp_id = _to$query2.corp_id) === null || _to$query2$corp_id === void 0 ? void 0 : _to$query2$corp_id.toString()) || '';
        initCompany();
      }

      if (props.showAvatar) {
        dispatchAction('user', 'getUserDetail', {});
      }
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (props.showAvatar) {
                dispatchAction('user', 'getUserDetail', {});
              }

              initCompany();

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));
    return function (_ctx, _cache) {
      var _component_el_divider = _resolveComponent("el-divider");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_popover = _resolveComponent("el-popover");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(headerLogo) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        src: _unref(headerLogo),
        alt: "",
        class: "link",
        onClick: clickLogoHandler
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [__props.showBizlist ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_select, {
        modelValue: bizId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return bizId.value = $event;
        }),
        class: "biz-select",
        "popper-class": "biz-options",
        teleported: false,
        onChange: changeBiz
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bizOptions), function (item, index) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              value: item.value,
              label: item.label
            }, {
              default: _withCtx(function () {
                return [_unref(showNewSpace) && index === _unref(bizOptions).length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 0,
                  style: {
                    "margin": "4px 0"
                  }
                })) : _createCommentVNode("", true), _createElementVNode("div", {
                  class: "add-biz",
                  onMousedown: _cache[0] || (_cache[0] = function (e) {
                    return e.preventDefault();
                  }),
                  onClick: openNewBizPage
                }, _hoisted_9, 32)])) : (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  placement: "top-end",
                  "show-after": 300
                }, {
                  content: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item.label), 1)];
                  }),
                  default: _withCtx(function () {
                    return [_createTextVNode(" " + _toDisplayString(item.label), 1)];
                  }),
                  _: 2
                }, 1024))];
              }),
              _: 2
            }, 1032, ["value", "label"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), __props.showHelp && _unref(helpDoc) && _unref(showHelpDoc) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_tooltip, {
        placement: "bottom"
      }, {
        content: _withCtx(function () {
          return [_hoisted_11];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("a", {
            class: "help-doc",
            href: _unref(helpDoc),
            target: "_blank"
          }, _hoisted_14, 8, _hoisted_12)];
        }),
        _: 1
      })])) : _createCommentVNode("", true), __props.showAvatar ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_popover, {
        placement: "bottom-end",
        "popper-class": "nav-avatar-popover",
        width: "auto",
        teleported: false
      }, {
        reference: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_16, [_unref(userDetail).avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(userDetail).avatar,
            class: "user avatar",
            alt: ""
          }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("img", _hoisted_18))])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(_unref(userDetail).name), 1), _createElementVNode("span", null, _toDisplayString(_unref(userDetail).email), 1)]), _unref(showSettingMenu) ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [_unref(showCompanyList) ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("a", {
            href: "".concat(_unref(baseRouter)).concat(_unref(menuMap).companyList, "?not_skip=1"),
            target: "_blank"
          }, _hoisted_26, 8, _hoisted_23)])) : _createCommentVNode("", true), _unref(showCompanySetting) ? (_openBlock(), _createElementBlock("li", _hoisted_27, [_createElementVNode("a", {
            href: "".concat(_unref(baseRouter), "/company/").concat(corporationId.value, "/basic"),
            target: "_blank"
          }, _hoisted_31, 8, _hoisted_28)])) : _createCommentVNode("", true), _unref(showUserAccount) ? (_openBlock(), _createElementBlock("li", _hoisted_32, [_createElementVNode("a", {
            href: "".concat(_unref(baseRouter)).concat(_unref(menuMap).account),
            target: "_blank"
          }, _hoisted_36, 8, _hoisted_33)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(showLogout) ? (_openBlock(), _createElementBlock("ul", _hoisted_37, [_createElementVNode("li", {
            class: "logout"
          }, [_createElementVNode("a", {
            href: "javascript:",
            onClick: logout
          }, _hoisted_40)])])) : _createCommentVNode("", true)])];
        }),
        _: 1
      })])) : _createCommentVNode("", true)])], 512);
    };
  }
});